import { useQuery } from '@tanstack/react-query';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { ShopsApiAdapter } from '../adapters/ShopsApiAdapter';

/**
 * Hook para obtener la lista de tiendas para usar en dropdowns/selects
 */
export const useShopsDropdown = () => {
  const httpClient = createHttpClient(apiClientWH);
  const shopsAdapter = new ShopsApiAdapter(httpClient);

  const { data, isLoading, error } = useQuery({
    queryKey: ['cod-payout-items-shops-dropdown'],
    queryFn: async () => {
      const shops = await shopsAdapter.getAll();
      // Ordenar alfabéticamente
      shops.sort((a, b) => a.name.localeCompare(b.name));
      return shops;
    },
    staleTime: 5 * 60 * 1000, // 5 minutos
    gcTime: 10 * 60 * 1000, // 10 minutos
  });

  return {
    shops: data || [],
    isLoading,
    error: error?.message || null,
  };
};

